import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PhoneNumber } from '../../common/interfaces/phone-number.interface';
import { User } from '../../common/interfaces/user.interface';

@Injectable()
export class CommonUserService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    findAll(linkedToAtLeastOneOrder = false, withRole = false): Observable<User[]> {
        let params = new HttpParams();
        params = params.append('excludeSystemUser', 'true');
        if (linkedToAtLeastOneOrder) {
            params = params.append('linkedToAtLeastOneOrder', 'true');
        }
        if (withRole) {
            params = params.append('withRole', 'true');
        }
        return this.http.get(this.getApiUrl() + '/app-users', { params })
            .pipe(
                map((res: any) => res || []),
                map((users: User[]) => users.map((user: User) =>
                    ({
                        ...user,
                        phone: PhoneNumber.fromData(user.phone as string),
                        mobilePhone: PhoneNumber.fromData(user.mobilePhone as string)
                    })
                ))
            );
    }
}
